import { render, staticRenderFns } from "./contragent-editor.vue?vue&type=template&id=061ecee8"
import script from "./contragent-editor.vue?vue&type=script&lang=js"
export * from "./contragent-editor.vue?vue&type=script&lang=js"
import style0 from "./contragent-editor.vue?vue&type=style&index=0&id=061ecee8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports